<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Comentário</th>
        <th scope="col" class="text-center border-0">Status</th>
        <th scope="col" class="text-center border-0">Id do Pai</th>
        <th scope="col" class="border-0">Criado em</th>
        <th scope="col" class="text-center border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in comments" :key="index" @click="editComment(null)">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <span @click.stop="editComment(row.id)" v-if="row.id !== editable">{{ row.comment }}</span>
          <textarea @click.stop="" @change="changedComment(row)" rows="3" class="form-control" v-model="row.comment" v-else></textarea>
        </td>
        <td class="td-3">
          <d-select v-model="row.status" @change="changedComment(row)">
            <option :value="null">Filtro por status</option>
            <option :value="status.value" v-for="status in statuses" :key="status.value">{{ status.name }}</option>
          </d-select>
        </td>
        <td class="text-center td-3 link">
          <span :id="`parent-${row.id}`">{{ row.parent_id }}</span>
          <d-tooltip :target="`#parent-${row.id}`" container=".parent--tooltip-01" v-if="row.parent">
            {{row.parent.comment}}
          </d-tooltip>
        </td>
        <td class="td-2">{{ row.created_at }}</td>
        <td class="text-center td-2">
          <comment-buttons :comment="row"></comment-buttons>
        </td>
      </tr>
      <tr v-if="comments.length === 0">
        <td colspan="6" class="no-content">Ainda não tem nenhum comentário cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de comentário"
      message="Tem certeza que deseja excluir este comentário?"/>
  </table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import CommentService from '_services/rest/modules/comment';
import CommentButtons from './CommentButtons.vue';
import CommentDelete from './CommentDelete';
import { _DELETE_COMMENT_ } from './CommentModel';

export default {
  name: 'comment-table',
  mixins: [CommentDelete],
  components: {
    CommentButtons,
    ConfirmationModal,
  },
  props: {
    comments: {
      type: Array,
    },
  },
  computed: {
    ...mapState({
      statuses: state => state.comment.statuses,
    }),
  },
  data() {
    return {
      selectComment: null,
      editable: false,
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    editComment(index) {
      if (this.editable !== index) {
        this.editable = index;
        return this.editable;
      }
      this.editable = null;
      return this.editable;
    },
    changedComment(row) {
      CommentService.save(row)
        .then(() => {
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Comentário alterado com sucesso', theme: 'success' });
        });
    },
  },
  mounted() {
    this._onDeleteComment = comment => { this.selectComment = comment.id; };
    Events.$on(_DELETE_COMMENT_, this._onDeleteComment);
  },
  beforeDestroy() {
    Events.$off(_DELETE_COMMENT_, this._onDeleteComment);
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/overrides';

.link {
  color: $primary;
  span {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
